import { MyFleetEndpointFactory } from '../app/components/myfleet/myfleet.endpoint.factory';
import { ShellEndpointFactory } from '../app/components/shell/shell.endpoints.factory';
import { RolesEndpointFactory, ServiceManagementEndpointFactory, DashboardEndpointFactory } from './interfaces';
import { AuthEndpointFactory } from './interfaces/endpoints/auth/auth.endpoint.factory';
import { EnvironmentRef } from './interfaces/environment.interface';
import { setURL } from './url-config';


const apiBaseUrl: string = setURL('QA_API_BASE_URL');
const sitecoreBaseUrl: string = setURL('QA_SITECORE_BASE_URL');
const aemBaseUrl: string = setURL('QA_AEM_BASE_URL');
const requestServiceUrl: string = setURL('QA_REQUEST_SERVICE_URL');
const buyPartsUrl: string = setURL('QA_BUY_PARTS_URL');
const manageFinancingUrl: string = setURL('QA_MANAGE_FINANCING_URL');
const openContactFormUrl: string = setURL('QA_OPEN_CONTACT_FORM_URL');
const requestServiceEquipmentDetails: string = setURL('QA_REQUEST_SERIVCE_EQUIPMENT_DETAILS');
const warrantyPromoBannerUrl: string = setURL('QA_WARRANTY_PROMO_BANNER_URL');
const buyPartsPromoBannerUrl: string = setURL('QA_BUY_PARTS_PROMO_BANNER_URL');
const azureKey: string = setURL('QA_AZURE_KEY');
const appWalkmeUrl: string = setURL('QA_APP_WALK_URL');
const shopDeliveryAddressUrl: string = setURL('QA_SHOP_DELIVERY_ADDRESS_URL');
const zendeskChatbotUrl: string = setURL('QA_ZEN_DESKCHATBOT_URL');
const raymondEnvironment: boolean = true;
const myInsightsPortalUrl: string = 'https://toyotaqa.npgtssweb.com/';
const ecomBaseUrl: string = 'https://shop-qa.toyotaforklift.com';
const raymondAnalyticsUrl: string = setURL('QA_RAYMOND_ANALYTICS_URL');
const raymondGtagId: string = setURL('QA_RAYMOND_ANALYTICS_GTAG');
const clarityId: string = setURL('QA_MSCLARITY_ID');

export const environment: EnvironmentRef = {
	production: false,
	isRaymond: raymondEnvironment || false,
	env: 'qa',
	baseUrl: apiBaseUrl,
	endpoints: {
		auth: AuthEndpointFactory.build(`${apiBaseUrl}`),
		roles: RolesEndpointFactory.build(`${apiBaseUrl}`),
		header: ShellEndpointFactory.build(`${apiBaseUrl}`),
		myfleetlabels: MyFleetEndpointFactory.build(`${apiBaseUrl}`),
		serviceManagement: ServiceManagementEndpointFactory.build(`${apiBaseUrl}`),
		dashboard: DashboardEndpointFactory.build(`${apiBaseUrl}`)
	},
	b2cPolicies: {
		names: {
			signUpSignIn: 'B2C_1A_IW_CONNECT_SSO_DEV_SIGNUPSIGNIN',
			editProfile: ''
		},
		authorities: {
			signUpSignIn: {
				authority:
          'https://login.tmhrnd.com/login.tmhrnd.com/B2C_1A_IW_CONNECT_SSO_DEV_SIGNUPSIGNIN'
			},
			editProfile: {
				authority: ''
			}
		},
		authorityDomain: 'login.tmhrnd.com'
	},
	clientId: 'd9b34d2f-5147-42bb-bf48-1bdd046ddefb',
	scope: {
		read: 'https://login.tmhrnd.com/iw_connect/iw_connect.read'
	},
	aemBaseUrl: aemBaseUrl,
	sitecoreBaseUrl: sitecoreBaseUrl,
	appWalkmeUrl: appWalkmeUrl,
	zendeskChatbotUrl: zendeskChatbotUrl,
	azureMapsApiKey: azureKey,
	requestServiceUrl: requestServiceUrl,
	buyPartsUrl: buyPartsUrl,
	manageFinancingUrl: manageFinancingUrl,
	openContactFormUrl: openContactFormUrl,
	requestServiceEquipmentDetails: requestServiceEquipmentDetails,
	warrantyPromoBannerUrl: warrantyPromoBannerUrl,
	buyPartsPromoBannerUrl: buyPartsPromoBannerUrl,
	shopDeliveryAddressUrl: shopDeliveryAddressUrl,
	myInsightsPortalUrl: myInsightsPortalUrl,
	analytics: {
		scripts: {
			launch: {
				src: 'https://assets.adobedtm.com/81c40e86aed0/bef7f0d1cfa1/launch-414b8a695cd7-staging.min.js'
			}
		}
	},
	raymondAnalytics: {
		scripts: {
			launch: {
				src: raymondAnalyticsUrl,
				gtag: raymondGtagId
			}
		}
	},
	msClarityId: clarityId,
	ecomBaseUrl: ecomBaseUrl
};

